/** Defines the React context for sharing task-specific UI configurations and state. */
// @ts-check
import { createContext } from 'react';

export const TaskUIContext = createContext(null);
